import React, { useState } from "react";
import {
  Autocomplete,
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { LoadingButton } from "@mui/lab";
import { useDialog } from "../../DialogContext";
import { backend_api } from "../../../static/server";
import { DocCategoryApiField } from "../Settings/FieldsUi/InputFields";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  createDocFolder,
  getAllDocFolder,
  getFolderById,
} from "../../../redux/Apps/Lawyerapp/DocumentSlice/DocumentSlice";

const CreateFolderForm = ({
  isEditMode,
  editfolderData,
  currentFolderData,
}) => {
  console.log(currentFolderData);
  const dispatch = useDispatch();
  const { closeDialog } = useDialog();
  const [editFolderId, setEditFolderId] = useState(null);
  const { token } = useSelector((state) => state.user);
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({});

  const onSubmit = async (data) => {
    console.log(data);
    try {
      if (isEditMode && editFolderId) {
        console.log("good folder");
      } else {
        await dispatch(
          createDocFolder({
            url: `${backend_api}documents/document/folder/`,
            body: {
              ...data,
              ...(currentFolderData?.id && { parent: currentFolderData.id }),
            },
            token: token,
          })
        ).unwrap();
        toast.success("Folder created successfully!");
      }
    } catch (error) {
      console.error("Failed to save Folder:", error);
      toast.error(
        isEditMode ? "Failed to update Folder" : "Failed to create folder"
      );
    } finally {
      closeDialog();
      reset();
      if (currentFolderData && currentFolderData?.id) {
        dispatch(
          getFolderById({
            url: `${backend_api}documents/document/folder/`,
            token: token,
            folderId: currentFolderData?.id,
          })
        );
      }
      dispatch(
        getAllDocFolder({
          url: `${backend_api}documents/document/folder/`,
          token: token,
          // teamMemberLawyerId: teamMemberLawyerId,
        })
      );
    }
  };

  return (
    <>
      <Box>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              gap: "1rem",
              p: "1rem",
            }}
          >
            <Controller
              name="folder_name"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Folder Name"
                  size="small"
                  fullWidth
                />
              )}
            />
            <Controller
              name="category"
              control={control}
              rules={{ required: "Category is required" }}
              render={({ field: { onChange, value } }) => (
                <DocCategoryApiField
                  name="category"
                  label="Document Category"
                  value={value}
                  onChange={onChange}
                  errors={errors}
                  token={token}
                  apiUrl={`${backend_api}documents/category/`}
                  isRequired={true}
                  // editData={
                  //   editData?.category
                  //     ? {
                  //         id: editData.category.id,
                  //         category_name: editData.category.category_name,
                  //       }
                  //     : null
                  // }
                  createCategoryDialogTitle="Create New Category"
                  noDataText="No categories found. Create one to get started!"
                  addButtonText="Add New Category"
                  placeholder="Search and select category"
                  formatApiResponse={(data) => {
                    return data.res;
                  }}
                />
              )}
            />
          </Box>
          <Box
            sx={{
              height: "fit-content",
              borderTop: "1px solid #ddd",
              position: "sticky",
              bottom: 0,
              backdropFilter: "blur(10px)",
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              p: "0.5rem",
              zIndex: 1000,
              gap: "0.5rem",
            }}
          >
            <Button
              size="small"
              variant="outlined"
              onClick={() => closeDialog()}
            >
              Cancel
            </Button>
            <LoadingButton
              size="small"
              variant="contained"
              type="submit"
              color="primary"
            >
              Create Folder
            </LoadingButton>
          </Box>
        </form>
      </Box>
    </>
  );
};

export default CreateFolderForm;
